<div class="VIPOnboardingTrigger">
  <div class="VIPOnboardingTrigger-Button" (click)="click()"> VIP
    <span></span><span></span><span></span>
  </div>
  <div class="VIPOnboardingTrigger-Text">Book onboarding call!</div>
</div>
